import React, { useMemo } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import { Bar } from 'react-chartjs-2'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const NewMembersBarChart = ({ data = {} }) => {
  const totalMembers = data?.total_new_users ?? 0
  const graphData = useMemo(() => {
    const safeDivide = (num) => (totalMembers ? (num / totalMembers) * 100 : 0)
    return {
      labels: [''],
      datasets: [
        {
          label: 'AWC-Attributed Sign-Ups',
          data: [safeDivide(data?.total_awc_and_alo_linked ?? 0)],
          backgroundColor: '#2196F3'
        },
        {
          label: 'Links from ALO Access',
          data: [safeDivide(data?.new_alo_users_verified_in_awc ?? 0)],
          backgroundColor: '#FFC107'
        }
      ]
    }
  }, [data, totalMembers])

  const options = useMemo(
    () => ({
      responsive: true,
      indexAxis: 'y',
      plugins: {
        title: {
          display: true,
          text: 'Percentage of New Members'
        },
        legend: {
          position: 'bottom'
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              let label = context.dataset.label || ''
              if (label) label += ': '
              const rawValue = Math.round((context.raw * totalMembers) / 100)
              label += `${rawValue} (${context.raw.toFixed(1)}%)`
              return label
            }
          }
        }
      },
      scales: {
        x: {
          stacked: false,
          max: 100,
          min: 0,
          title: {
            display: true,
            text: 'Percentage (%)'
          }
        },
        y: {
          stacked: false
        }
      }
    }),
    [totalMembers]
  )

  return (
    <div
      style={{ width: '100%', maxWidth: 600, padding: 10, margin: '0 auto' }}
    >
      <Bar data={graphData} options={options} />
    </div>
  )
}

export default NewMembersBarChart
